import React, { Component } from 'react';
import logoicon from '../img/icono.png';
import valores from '../img/valores.jpg';
import vision from '../img/vision.jpg';
import mision from '../img/mision.jpg';
import '../css/Nosotros.css';
class Nosotros extends Component {
  render() {

    return (
      <div id="id-nosotros" className="nosotrosContenedor">
        <div className="nosotrosCuadro"></div>
        <div className="cuadro1">
          <h2 className="titulonosotros">Nosotros</h2>
          <h5 className="titulonosotros2">Nuestra Historia y valores</h5>
          <hr className="bordenosotros"></hr>
        </div>
        <div className="NosotrosProteccion" id="nosotrosproteccion1">
          <div className="proteccionImagen">
            <img className="imagenContenido" src={logoicon}></img>
          </div>
          <div className="campoContenido">
            <h2 className="titulonosotros">Quienes Somos</h2>
            <p className="parrafonosotros">Somos una empresa peruana con mas de 15 años dedicada a desarrollar </p>
            <p className="parrafonosotros">soluciones en sistemas informáticos de calidad, con la experiencia</p>
            <p className="parrafonosotros">necesaria para colaborar con los objetivos de nuestros clientes. </p>
          </div>
        </div>
        <div className="NosotrosProteccion" id="nosotrosproteccion2">
          <div className="proteccionImagen">
            <img className="imagenContenido" src={valores}></img>
          </div>
          <div className="campoContenido2">
            <h2 className="titulonosotros">Valores</h2>
            <p className="parrafonosotros">La honradez en cada uno de nuestros actos,Trabajo en Equipo.  </p>
            <p className="parrafonosotros">La satisfacción de nuestros clientes como objetivo principal.</p>
            <p className="parrafonosotros">Responsabilidad en el manejo de información de nuestros clientes. </p>
          </div>
        </div>
        <div className="NosotrosProteccion" id="nosotrosproteccion3">
          <div className="proteccionImagen">
            <img className="imagenContenido" src={vision}></img>
          </div>
          <div className="campoContenido3">
            <h2 className="titulonosotros">Vision</h2>
            <p className="parrafonosotros">Poder llegar a diferentes negocios con una herramienta útil y confiable</p>
            <p className="parrafonosotros">que cubra todas las expectativas de las diferentes unidades operativas</p>
            <p className="parrafonosotros">y que el crecimiento de nuestra empresa se pueda basar en </p>
            <p className="parrafonosotros">la satisfacción de nuestros clientes y en la seriedad </p>
            <p className="parrafonosotros">con la que manejamos la información de cada uno de ellos.</p>
          </div>
        </div>
        <div className="NosotrosProteccion" id="nosotrosproteccion4">
          <div className="proteccionImagen">
            <img className="imagenContenido" src={mision}></img>
          </div>
          <div className="campoContenido4">
            <h2 className="titulonosotros">Mision</h2>
            <p className="parrafonosotros">Desarrollar soluciones informáticas confiables para impulsar </p>
            <p className="parrafonosotros">el crecimiento empresarial, brindando calidad y un excelente servicio a nuestros clientes</p>
            <p className="parrafonosotros">Proporcionar Software de Gestión para mejorar la productividad, mayor eficiencia y ahorro a nuestros clientes,</p>
            <p className="parrafonosotros">con profesionales comprometidos y capacitados utilizando estándares y tecnología de vanguardia en la construcción de software.</p>
          </div>
        </div>
        <div className="Nosotroscampus">
          <h4 className="h4nosotros">Gran Equipo</h4>
        </div>
      </div>
    )
  }



}

export default Nosotros;


// WEBPACK FOOTER //
// ./src/components/Nosotros.jsx